import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import useTranslate from '../../../../localization/helpers';
import { usePermissionGranted } from '../../../hooks/usePermissionGranted';
var UnAuthorized = function () {
    var state = useLocation().state;
    var translate = useTranslate().translate;
    var hasPermission = usePermissionGranted({ permissions: state.permissions });
    var containerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: 'rgb(245, 245, 245)',
        color: 'rgb(0, 153, 131)',
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif'
    };
    var errorCodeStyle = {
        fontSize: '10rem',
        fontWeight: 'bold',
        color: 'rgb(0, 153, 131)'
    };
    var messageStyle = {
        fontSize: '2rem',
        fontWeight: '700',
        color: '#333333',
        marginTop: '10px'
    };
    var descriptionStyle = {
        fontSize: '1.2rem',
        color: '#666666',
        marginTop: '10px'
    };
    return hasPermission ? (_jsx(Navigate, { to: state.pathname })) : (_jsx("div", { style: containerStyle, children: _jsxs("div", { children: [_jsx("div", { style: errorCodeStyle, children: "401" }), _jsx("div", { style: messageStyle, children: translate('unauthorized.unauthorizedText') }), _jsx("div", { style: descriptionStyle, children: translate('unauthorized.unauthorizedDescription') })] }) }));
};
export default UnAuthorized;
